module.exports = __webpack_public_path__ + "img/expand-icon.74a4adb2.svg";